package org.matthewo.datasource

import org.matthewo.api.Schedule

object FTCEvents {

    private const val BASE_ROUTE = "https://ftc-events.firstinspires.org"

    fun teamURL(number: Int) = "$BASE_ROUTE/team/$number"

    fun eventURL(year: Any, code: String) = "$BASE_ROUTE/$year/$code"

    fun resultsURL(year: Int, code: String, level: Schedule.Match.Level, number: Int, series: Int = -1) =
        "${eventURL(year, code)}/${if (level == Schedule.Match.Level.QUAL) "qualifications/$number" else "playoff/$series/$number"}"
}
